//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SearchByLeagueOrVenue.css'
import { useNavigate } from 'react-router-dom'
import coolHockeyLogo from '../../images/CHE-logo-x2.png'
//import { FaTrophy, FaUsers, FaShieldAlt, FaChevronDown } from 'react-icons/fa'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByLeagueOrVenue = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [loadedVenues, setLoadedVenues] = useState()
	const [error, setError] = useState()

	let selectedLeague, selectedTeam, selectedVenue, selectedDivision
	//******************************************************* */
	//
	//Call backend to get all the current leagues for our dropdown
	//
	//    admin-controller   getCurrentLeagues
	//
	//******************************************************** */
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLoadedDivisions(responseData.divisions)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues])

	let leagueArray, divisionArray

	if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay = league.leagueName + ' - ' + league.year
			leagueArray.push(leagueDisplay)
		})
	}
	//
	if (loadedDivisions && !isLoading) {
		divisionArray = []
		loadedDivisions.forEach((div) => {
			divisionArray.push(div)
		})
	}
	//
	//
	//
	//*********************************************** */
	//
	//Call backend to get all the current TEAMS for our dropdown
	//
	//     league-controller    getAllCurrentTeams
	//
	//*********************************************** */
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.currentTeamsArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [setLoadedTeams])

	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}
	//
	//********************************************************** */
	//
	//Call backend to get all the current VENUES for our dropdown
	//
	//      admin-controller      getVenues
	//
	//********************************************************** */
	useEffect(() => {
		const sendRequest3 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/venues',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedVenues(responseData.allVenues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest3()
	}, [setLoadedVenues])

	let venueArray

	if (loadedVenues && !isLoading) {
		venueArray = []
		loadedVenues.forEach((venue) => {
			//const teamDisplay = team
			venueArray.push(venue.venueName)
		})
	}

	let navigate = useNavigate()

	//For handling a search by team request:
	/*
	const handleChange1 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = teamArray[selectedValue]
		const teamId = selectedTeam._id
		navigate(`/league/teamSchedule/${teamId}`)
	} */

	//For handling a search by team request:
	const handleChange1 = (e) => {
		e.preventDefault()
		if (e.target.value === '') return

		const selectedValue = e.target.value
		selectedTeam = teamArray[selectedValue]
		const teamId = selectedTeam._id
		navigate(`/league/teamSchedule/${teamId}`)
	}

	//For handling a search by league request:
	const handleChange = (e) => {
		e.preventDefault()
		if (e.target.value === '') return

		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else {
			const selectedValue = e.target.value
			selectedLeague = loadedLeagues[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/schedule/${leagueId}`)
		}
	}
	/* const handleChange = (e) => {
		e.preventDefault()
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Search for Tournament Schedule....') {
			const selectedValue = e.target.value
			selectedLeague = loadedLeagues[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/schedule/${leagueId}`)
		}
	} */

	//For handling a search by VENUE request
	const handleChange3 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedVenue = loadedVenues[selectedValue]
		const venueId = selectedVenue._id
		navigate(`/league/${venueId}/schedule`) //< - - - should go to VenueSchedule
	}

	//For handling a search by DIVISION request
	const handleChange4 = (e) => {
		e.preventDefault()
		if (e.target.value === '') return

		const selectedValue = e.target.value
		selectedDivision = loadedDivisions[selectedValue]
		const divisionId = selectedDivision._id
		const divisionName = selectedDivision.divisionName
		const leagueId = selectedDivision.leagueId
		navigate(`/league/${divisionName}/${leagueId}/${divisionId}/schedule`)
	}

	/* const handleChange4 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedDivision = loadedDivisions[selectedValue]
		console.log('selected Division: ' + JSON.stringify(selectedDivision))
		const divisionId = selectedDivision._id
		const divisionName = selectedDivision.divisionName
		const leagueId = selectedDivision.leagueId
		navigate(`/league/${divisionName}/${leagueId}/${divisionId}/schedule`) //< - - - should go to DivisionSchedule
	} */

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='scheduleSearchCard'>
					<div className='scheduleSearchLogos'>
						<div className='scheduleSearchLine'></div>
						<img
							src={coolHockeyLogo}
							className='coolHockeyLogo scheduleSearchLogo'
							alt='Cool Hockey Events'
						/>
						<div className='scheduleSearchLine'></div>
					</div>

					<div className='scheduleSearchDropdowns'>
						{!isLoading && loadedLeagues && (
							<div className='scheduleSearchRow2'>
								<select
									className='scheduleselectorhomepage'
									onChange={handleChange}
								>
									<option value=''>Tournament</option>
									{leagueArray.map((league, i) => (
										<option value={i} key={i}>
											{league}
										</option>
									))}
									<option value='*Previous Tournaments*'>
										*Previous Tournaments*
									</option>
								</select>
							</div>
						)}

						{!isLoading && loadedTeams && (
							<div className='scheduleSearchRow2'>
								<select
									className='scheduleselectorhomepage'
									onChange={handleChange1}
								>
									<option value=''>Team</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.divisionName + ' >>> ' + team.teamName}
										</option>
									))}
								</select>
							</div>
						)}

						{!isLoading && loadedDivisions && (
							<div className='scheduleSearchRow2'>
								<select
									className='scheduleselectorhomepage'
									onChange={handleChange4}
								>
									<option value=''>Division</option>
									{divisionArray.map((division, i) => (
										<option value={i} key={i}>
											{division.divisionName}
										</option>
									))}
								</select>
							</div>
						)}
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default SearchByLeagueOrVenue
